import React from 'react';
import './index.css';

import bigicoadministra from 'assets/images/bigico-administra.png';
import bigicolibreta from 'assets/images/bigico-libreta.png';
import guiaeducacion from 'assets/images/bigico-guiaeducacion.png';
import organizadorFinanzasXLS from 'assets/descargas/organizador-finanzas-personales.xlsx';
import libretaFinanzasPDF from 'assets/descargas/libreta-educacion-financiera.pdf';
import guiaJovenesFinanzasPDF from 'assets/descargas/guia-educacion-financiera-jovenes.pdf';

function  Article({ variant }) {

  return (
    <div className='columns finanzas'>
      <div className='col'>
        <h4>¡Aprendé a administrar<br />tus finanzas!</h4>
        { variant === 'mayores' && (
          <>
            <p className='strong'>¡Descargá la Libreta Incluir y empezá a usarla ahora mismo!</p>
            <ul className='small-list'>
              <li>Banco Provincia, ha creado la <strong>Libreta Incluir</strong>, con el objetivo de simplificar el acceso a la información financiera y bancaria para los adultos mayores.</li>
              <li>Aborda los conceptos básicos de la educación financiera, desde las características de las tarjetas de débito y crédito hasta las acciones a tomar en caso de pérdida o robo. También destaca las ventajas de utilizar la billetera digital gratuita <strong>“Cuenta DNI”</strong>, una aplicación que permite realizar pagos, transferencias, recargas y otras funciones, y que ya es utilizada por casi 8 millones de personas.</li>
            </ul>
          </>
        )}
        { variant === 'micro' && (
          <>
            <p className='strong'>¡Descargá la Libreta Incluir y empezá a usarla ahora mismo!</p>
            <p>Vas a encontrar tips sobre tarjetas, las ventajas de usar la billetera digital Cuenta DNI, consejos de seguridad y qué operaciones realizar desde los canales digitales y electrónicos (Cajero automático; Cuenta DNI; BIP; BIP Móvil y Provincia NET).</p>
          </>
        )}
        { variant === 'adolescentes' && (
          <>
            <p className='strong'>Esta es la guía de Educación Financiera de Banco Provincia con la que queremos acompañarte a dar tus primeros pasos en finanzas personales.</p>
            <p>Te invitamos a recorrerla y conocer cuáles son las principales herramientas que ofrecen los bancos y que nos ayudan a administrar nuestro dinero, planificar el futuro y tomar decisiones seguras e informadas.</p>
          </>
        )}
        { variant === 'emprendedora' && (
          <>
            <p className='strong'>¡Descargá la Libreta Incluir y empezá a usarla ahora mismo!</p>
            <p>Vas a encontrar tips sobre tarjetas, las ventajas de usar la billetera digital Cuenta DNI, consejos de seguridad y qué operaciones realizar desde los canales digitales y electrónicos (Cajero automático; Cuenta DNI; BIP; BIP Móvil y Provincia NET).</p>
          </>
        )}
      </div>
      { variant === 'mayores' && (
        <>
          <div className='col'>
            <div className="bigbtn-container">
              <img src={bigicolibreta} alt="Icono de descarga" className='big-icon' />
              <a href={libretaFinanzasPDF} target='_blank' rel='noreferrer' className='btn-verde'>Descargar</a>
            </div>
          </div>
          <div className='col'>
            <div className="bigbtn-container">
              <img src={bigicoadministra} alt="Icono de descarga" className='big-icon' />
              <p>Descargá el Organizador de Finanzas Personales!</p>
              <a href={organizadorFinanzasXLS} target='_blank' rel='noreferrer' className='btn-verde'>Descargar</a>
            </div>
          </div>
        </>
      )}
      { variant === 'micro' && (
        <>
          <div className='col'>
            <div className="bigbtn-container">
              <img src={bigicolibreta} alt="Icono de descarga" className='big-icon' />
              <a href={libretaFinanzasPDF} target='_blank' rel='noreferrer' className='btn-verde'>Descargar</a>
            </div>
          </div>
          <div className='col col3'></div>
        </>
      )}
      { variant === 'adolescentes' && (
        <>
          <div className='col'>
            <div className="bigbtn-container">
              <p>¡Descargá la Guía Jóvenes y empezá a usarla ahora mismo!</p>
              <img src={guiaeducacion} alt="Guía de Educación Financiera" className='big-icon' />
              <a href={guiaJovenesFinanzasPDF} target='_blank' rel='noreferrer' className='btn-verde'>Descargar</a>
            </div>
          </div>
          <div className='col col3'></div>
        </>
      )}
      { variant === 'emprendedora' && (
        <>
          <div className='col'>
            <div className="bigbtn-container">  
              <img src={bigicolibreta} alt="Icono de descarga" className='big-icon' />
              <a href={libretaFinanzasPDF} target='_blank' rel='noreferrer' className='btn-verde'>Descargar</a>
            </div>
          </div>
          <div className='col col3'></div>
        </>
      )}
    </div>
  );
}

export default Article;
